import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {UsersAnagrafService} from '../../../general-services/service-users-anagraf/users-anagraf.service';
import {UnitsModel} from '../../../../models/UnitsModel';
import {map, startWith} from 'rxjs/operators';
import {UserModel} from '../../../../models/UserModel';
import { RoleModel } from 'src/models/RoleModel';

@Component({
  selector: 'app-user-role-filter',
  templateUrl: './user-role-filter.component.html',
  styleUrls: ['./user-role-filter.component.scss']
})
export class UserRoleFilterComponent extends ProjectConstants implements OnInit, OnDestroy {

  listFilterRoles: any[];
  rolesFormControl = new FormControl();
  rolesFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;
  

  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
  }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.listFilterRoles = [
      { "id": 1, "role": "admin" },  
      { "id": 2, "role": "gestore_lc" },  
      { "id": 3, "role": "gestore_contract" }     
    ]
    this.rolesFormControl.setValue(null);
  }

  reset() {
    this.rolesFormControl.setValue(null);
  }


  ngOnDestroy(): void {
  }

}
